import { LifeBuoy, Plug } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg, fmtDate } from "@/lib/api";

export const HelpCard = ({ reqs, m, onConnect, canConnect, onResolved }) => {
  const req = reqs[0];
  const resolve = () => Promise.all(reqs.map((r) => api.post(`/help-requests/${r.request_id}/resolve`)))
    .then(() => { toast.success("Demande marquée comme traitée"); onResolved(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="mx-5 mt-4 rounded-lg border border-red-200 bg-red-50 p-4" data-testid="help-card">
      <p className="flex items-center gap-2 font-semibold text-red-700"><LifeBuoy className="h-4 w-4" /> Demande d'aide</p>
      <p className="text-xs text-red-700/80 mt-0.5">{req.user || "Utilisateur"} · {fmtDate(req.at)}</p>
      <p className="mt-2 text-sm text-slate-800 whitespace-pre-wrap" data-testid="help-card-text">{req.text || "(sans message)"}</p>
      {reqs.length > 1 && <p className="text-xs text-red-700/80 mt-1">+ {reqs.length - 1} demande(s) précédente(s) : {reqs.slice(1).map((r) => r.text).join(" · ")}</p>}
      <div className="mt-3 flex gap-2">
        <Button size="sm" disabled={!m.online || !canConnect} onClick={() => onConnect(m)} data-testid="help-connect-btn"><Plug className="h-4 w-4 mr-1" /> Participer</Button>
        <Button size="sm" variant="outline" onClick={resolve} data-testid="help-resolve-btn">Marquer comme traitée</Button>
      </div>
    </div>
  );
};
